import { getDataStoreEntityMap } from '../../../modules/chat/dataStoreEntityMap'

const selectMessages = state => getDataStoreEntityMap(state.data.messages)

const MessageDataStoreSelectors = {
  messages: selectMessages
}

export default MessageDataStoreSelectors
